module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/buy-property-small.93db30accb347ef03cce6aa21a789ab4.jpg";